export default text => text;



// WEBPACK FOOTER //
// ./src/i18n/getAnnotateFunction.js